<template>
  <div class="index">
    <div class="footer">
      <div class="index-con">
        <div class="footer-nav">
          <div class="nav-list" @click="contactus">Contact us</div>
          <div class="nav-list" @click="tojoin">Join IRADSTM</div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="index-con">
        <p>&nbsp;</p>
        <p>Copyright © IRADSTM. All Rights Reserved</p>
        <p>&nbsp;</p>
        <p>
          International Research Association for Drying Science & Technology (Macao)
        </p>
        <p>&nbsp;</p>
        <p class="beian">
          <a target="_blank" title="51la网站统计" href=" "><img src="https://sdk.51.la/icon/3-3.png"></a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  onload() { },
  mounted() { },
  methods: {
    contactus(url) {
      this.$router.push("/web-content?news_id=31001");
    },
    tojoin(url) {
      this.$router.push("/richTextEditor?nav_title=Membership&nav_small_title=Join%20IRADSTM&nav_id=81&nav_pid=72");
    },
    toOther(url) {
      this.$router.push("/" + url);
    },
  },
};
</script>

<style scoped lang="less">
.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 0px;
}

.footer {
  padding: 40px 0 20px;

  .footer-text {
    color: #5b965a;
    margin-top: 20px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 16px;
    font-weight: 700;
  }

  img {
    width: 33px;
    height: auto;
    display: inline-block;
  }

  .nav-list {
    padding-bottom: 10px;
    font-family: Canaro, Arial, sans-serif;
    font-weight: 700;
    color: #1f1f1f;
    margin-right: 20px;
    cursor: pointer;
  }

  .footer-nav {
    display: flex;
    border-bottom: 1px solid grey;
  }
}

.index {
  width: 100%;
  background: hsla(0, 0%, 50.2%, 0.05);

  .bottom {
    background: #5b965a;
    color: #fff;
    box-sizing: border-box;
    padding: 10px 0;

    .index-con {
      padding-bottom: 0 !important;
    }

    p {
      font-size: 16px;
    }
  }
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .footer {
    padding: 30px 10px 10px;
    box-sizing: border-box;
  }

  .bottom {
    padding: 10px;
    box-sizing: border-box;

    .index-con {
      padding: 10px;
      box-sizing: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue